import { useSelector } from 'react-redux';
import { selectGates } from '../selectors/authSelectors';
import { useCallback } from 'react';
export const useGetIsUngated = () => {
  const gates = useSelector(selectGates);
  return useCallback(gate => {
    if (!gates) {
      return false;
    }
    return gates.includes(gate);
  }, [gates]);
};